<template>
  <div class="department-manage">
    <div class="main-content">
      <div class="page-title clearfix">
        <div class="float-left">
          <span>{{ $t("nav.department") }}</span>
          <span class="total-num">{{ totalCount }}</span>
        </div>
        <div class="float-right">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            @click="showAddPopover"
          >
            {{ $t("department.add") }}
          </button>
          <!-- <button type="button" class="btn btn-primary btn-sm ml10" @click.stop="handleShowManagerPopover">批量设置权限</button> -->
        </div>
      </div>
      <div class="department-content">
        <div class="search-wrapper">
          <span class="search-btn" @click.stop="handleSearch">{{
            $t("search")
          }}</span>
          <el-form
            :inline="true"
            :model="searchForm"
            class="search-form"
            size="small"
          >
            <el-form-item :label="$t('department.department')">
              <el-input
                v-model="searchForm.name"
                clearable
                placeholder=" "
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('department.manager')">
              <el-input
                v-model="searchForm.department_administrator"
                clearable
                placeholder=" "
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="tabel-content">
          <el-table
            ref="multipleTable"
            :data="departmentList"
            :empty-text="$t('no_data')"
            style="width: 100%"
            header-row-class-name="thead-dark"
          >
            <el-table-column
              prop="name"
              :label="$t('student.department')"
            ></el-table-column>
            <el-table-column
              prop="administrator"
              :label="
                $t('department.manager') + '(' + $t('sign.username') + ')'
              "
            >
              <template v-slot="scope">
                <span>
                  {{ scope.row.administrator }} ({{ scope.row.username }})
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="doctor_count"
              :label="$t('department.doctor_count')"
            ></el-table-column>
            <el-table-column
              prop="student_count"
              :label="$t('department.student_count')"
            ></el-table-column>
            <el-table-column
              prop="project_count"
              :label="$t('department.project_count')"
            ></el-table-column>
            <el-table-column
              prop="patient_count"
              :label="$t('department.patient_count')"
            ></el-table-column>
            <el-table-column
              prop="updated_at"
              :label="$t('department.update_time')"
            ></el-table-column>
            <el-table-column :label="$t('department.status')">
              <template v-slot="scope">
                <span>{{ scope.row.status | formatStatus }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column :label="$t('department.right')">
              <template v-slot="scope">
                <router-link
                  :to="{ name: 'departmentAuthority', query: { id: scope.row.id, name: scope.row.name } }"
                  >{{ $t("department.edit_right") }}</router-link
                >
              </template>
            </el-table-column> -->
            <el-table-column :label="$t('operate')" align="center" width="150">
              <template v-slot="scope">
                <span
                  class="cursor text-primary mr10"
                  @click="showEditPopover(scope.row)"
                  >{{ $t("department.modify") }}</span
                >
                <span
                  class="cursor text-danger"
                  @click="handleDeleteDepartment(scope.row.id)"
                  >{{ $t("delete") }}</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="clearfix mt-3 mb-3">
        <div class="float-left">
          <pagination
            v-if="totalCount > 0"
            :pageSize="pageSize"
            :layout="layout"
            :currentPage="currentPage"
            :total="totalCount"
            @goToPage="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <edit-model
      :showPopover="showPopover"
      :department="department"
      :popoverTitle="popoverTitle"
      :isAdd="isAdd"
      :appList="appList"
      :allappids="allappids"
      :reportTypeList="reportTypeList"
      :allReportTemplates="allReportTemplates"
      @closePopover="closePopover"
      @submitDepartment="submitDepartment"
    >
    </edit-model>
  </div>
</template>

<script>
import {
  departmentListRequest,
  addDepartmentRequest,
  editDepartmentRequest,
  deleteDepartment,
  getApplication,
  report_types,
} from "../../api/api";
import editModel from "../../components/department/editModel";
import pagination from "../../components/pager";
import { paginationMixin } from "../../utils/mixin";
import { MessageBox, Loading } from "element-ui";

let _that;

export default {
  mixins: [paginationMixin],
  components: {
    editModel,
    pagination,
  },
  data() {
    return {
      searchForm: {
        name: "",
        department_administrator: "",
      },
      departmentList: [],
      showPopover: false,
      department: {},
      popoverTitle: "",
      popoverType: "",
      isAdd: true,
      showSearchDrawer: false,
      value1: "",
      clearable: false,
      showManagerPopover: false,
      pageSize: 15,
      currentPage: 1,
      totalCount: 0,
      appList: [],
      allappids: [],
      reportTypeList: [], //报告类型列表
      allReportTemplates: [],
    };
  },
  created() {
    this.getReportTypes();
    this.getDepartmentData();
    this.getAppList();
  },
  mounted() {
    //监听键盘esc事件
    document.addEventListener("keyup", this.handleKeyup);
  },
  beforeDestroy() {
    //监听键盘esc事件
    document.removeEventListener("keyup", this.handleKeyup);
  },

  methods: {
    //监听键盘esc事件
    handleKeyup(event) {
      if (event.key === "Escape") {
        //console.log("Esc key pressed");
        // 执行你的逻辑
        this.closePopover();
      }
    },
    async getAppList() {
      let params = {
        modality: this.modality === "all" ? "" : this.modality,
      };
      try {
        let res = await getApplication(params);
        this.appList = res.data;
        this.allappids = res.data.map((item) => item.app_id);
      } catch (error) {
        this.$helper.errNotify(error.message);
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.pageSize = 15;
      this.getDepartmentData();
    },
    showSearchWrapper() {
      this.showSearchDrawer = true;
    },
    hideSearchWrapper() {
      this.showSearchDrawer = false;
    },
    async getDepartmentData() {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        ...this.searchForm,
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      try {
        let res = await departmentListRequest(params);
        if (res.status === 200) {
          this.departmentList = res.data.length > 0 ? res.data : [];
          this.totalCount = res.total || 0;
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    showAddPopover() {
      this.popoverTitle = this.$t("department.add");
      this.showPopover = true;
      this.popoverType = "add";
      this.isAdd = true;
      let limits = {
        analysis: "disable",
        appids: [],
        report: "disable",
        report_templates: [],
      };
      this.allappids;

      this.department = {
        name: "",
        administrator: "",
        email: "",
        password: "",
        username: "",
        title: "",
        telephone: "",
        analysisEnable: false,
        limits: limits,
      };
    },
    showEditPopover(department) {
      let appids =
        department.limits && department.limits.appids
          ? department.limits.appids
          : []; //this.allappids;

      let analysisDisable =
        department.limits &&
        department.limits.analysis &&
        department.limits.analysis == "disable"
          ? true
          : false;

      let reportDisable =
        department.limits &&
        department.limits.report &&
        department.limits.report == "disable"
          ? true
          : false;
      let templates =
        department.limits && department.limits.report_templates
          ? department.limits.report_templates
          : [];

      let limits = {
        analysis: analysisDisable ? "disable" : "enable",
        appids: appids,
        report: reportDisable ? "disable" : "enable",
        report_templates: templates,
      };

      console.log(
        "showEditPopover department",
        limits
        //   analysisDisable,
        //   this.allappids
      );
      this.department = {
        id: department.id || "",
        name: department.name || "",
        administrator: department.administrator || "",
        email: department.email || "",
        password: department.password || "",
        username: department.username || "",
        title: department.title || "",
        telephone: department.telephone || "",
        analysisEnable: !analysisDisable,
        limits: limits,
      };
      //console.log("this.department", this.department);
      this.popoverTitle = this.$t("department.edit_department");
      this.showPopover = true;
      this.popoverType = "edit";
      this.isAdd = false;
    },
    closePopover() {
      this.department = {};
      this.popoverTitle = "";
      this.showPopover = false;
      this.popoverType = "";
    },
    submitDepartment(department) {
      // console.log(
      //   "submitDepartment",
      //   department.limits
      //   //   analysisDisable,
      //   //   this.allappids
      // );
      // 权限JSON,{analysis:'disable'|'enable', appids:[]}
      // analysis 与 appids 独立，提交前按开关值同步 analysis 字段。
      department.limits.analysis = department.analysisEnable
        ? "enable"
        : "disable";

      if (this.popoverType === "add") {
        this.handleAddDepartment(department);
      } else if (this.popoverType === "edit") {
        this.handleEditDepartment(department);
      }
    },
    async handleAddDepartment(department) {
      let _self = this;
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        let res = await addDepartmentRequest(department);
        if (res.status === 200) {
          this.$helper.successNotify(res.message, function () {
            _self.getDepartmentData();
          });
          this.closePopover();
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    async handleEditDepartment(department) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        id: department.id,
        name: department.name,
        title: department.title,
        email: department.email,
        password: department.password,
        username: department.username,
        telephone: department.telephone,
        administrator: department.administrator,
        limits: department.limits,
      };
      try {
        let res = await editDepartmentRequest(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getDepartmentData();
          this.closePopover();
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    handleDeleteDepartment(id) {
      MessageBox.confirm(this.$t("notice.p_confirm"), this.$t("notice.tips"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning",
      })
        .then(() => {
          this.deleteDepartment(id);
        })
        .catch(() => {});
    },
    async deleteDepartment(id) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        let res = await deleteDepartment({ id: id });
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getDepartmentData();
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDepartmentData();
    },
    handleShowManagerPopover() {
      this.showManagerPopover = true;
    },
    handleHideManagerPover() {
      this.showManagerPopover = false;
    },
    async getReportTypes() {
      try {
        let res = await report_types();
        if (res.status === 200 && res.data.length) {
          console.log(res.data);
          res.data.forEach((item) => {
            item.template = parseInt(item.template);
          });
          this.reportTypeList = res.data;
          this.allReportTemplates = res.data.map((item) => item.template);
        } else {
          this.reportTypeList = [];
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  beforeCreate() {
    _that = this;
  },
  filters: {
    formatStatus: function (status) {
      switch (status) {
        case "0":
          return _that.$t("student.close");
        case "1":
          return _that.$t("student.open");
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.table {
  border-bottom: 1px solid #dee2e6;
}
.department-manage {
  .el-checkbox {
    margin-bottom: 0;
    width: 200px;
  }
  .form-item {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
